var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.334,24H2.667A2.67,2.67,0,0,1,0,21.334V2.667A2.67,2.67,0,0,1,2.667,0H21.334A2.67,2.67,0,0,1,24,2.667V21.334A2.67,2.67,0,0,1,21.334,24ZM2.667,2.667V21.334H21.334V2.667ZM20,18.667H4L8,13.52l2.853,3.453,4-5.16L20,18.665Z",
    transform: "translate(0.5 0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.9a211aa24a6644e554867dc884f86e8b.svg";
export { ForwardRef as ReactComponent };